module.exports = __webpack_public_path__ + "static/ab-62b023d0810001f8aab6608dd397e49b.png";